const selectedFilters = (state) => {
  let filters = [];
  Object.keys(state.filters).forEach((key) => {
    const selected = state.filters[key].options
      .filter((f) => f.selected)
      .map((s) => {
        return {
          title: s.title,
          type: key,
          value: s.value,
          icon: s.icon,
          color: s.color,
        };
      });
    filters = filters.concat(selected);
  });
  return filters;
};

const getPageAmountHistories = (state, histories) => {
  const count = 9 * state.page;
  const res = {
    loaded: 0,
    municipalities: {},
  };
  let addedItemsCount = 0;
  let i = 0;
  const keys = Object.keys(histories);
  while (keys.length > i && count > addedItemsCount) {
    const key = keys[i];
    const muni = histories[key];
    res.municipalities[key] = {
      title: muni.title,
      histories: [],
    };
    let j = 0;
    while (muni.histories.length > j && count > addedItemsCount) {
      res.municipalities[key].histories.push(muni.histories[j]);
      j++;
      addedItemsCount++;
    }
    i++;
  }
  res.loaded = addedItemsCount;
  return res;
};

const historiesByMunicipality = (state) => {
  const municipalities = {};
  const filteredHistories = state.filteredHistories;

  filteredHistories.forEach((history) => {
    if (history.municipalities.length > 0) {
      history.municipalities.forEach((muni) => {
        if (municipalities[muni]) {
          municipalities[muni].histories.push(history);
        } else {
          municipalities[muni] = {
            title: state.filters.municipalities.options.find(
              (m) => m.value === muni
            ).title,
            histories: [history],
          };
        }
      });
    } else {
      if (municipalities["other"]) {
        municipalities["other"].histories.push(history);
      } else {
        municipalities["other"] = {
          title: "Övriga",
          histories: [history],
        };
      }
    }
  });
  const orderedMunicipalities = Object.keys(municipalities)
    .sort((a, b) =>
      municipalities[a].title.localeCompare(municipalities[b].title, "sv", {
        sensitivity: "base",
      })
    )
    .reduce((obj, key) => {
      obj[key] = municipalities[key];
      return obj;
    }, {});

  return getPageAmountHistories(state, orderedMunicipalities);
};

const filteredHistories = (state) => {
  return state.filteredHistories.slice(0, state.postsPerPage * state.page);
}

const postsLeft = (state) => {
  return state.histories.length - filteredHistories(state).length;
};

const getters = {
  selectedFilters,
  historiesByMunicipality,
  filteredHistories,
  postsLeft
};

export default getters;
